<template>
    <div
        id="ChatHistoryListTwo"
        :style="{
            background: `linear-gradient(0deg,${backgroundColorFirst},${backgroundColorSecond}) !important`,
        }"
    >
        <div v-if="selectedConversationId === undefined && !loading" class="list-container">
            <div class="header">
                <Input
                    inputType="text"
                    placeHolder="Search Chat"
                    @v-model="(e) => (searchValue = e)"
                    :value="searchValue"
                    firstIcon="Search"
                />
            </div>
            <div class="list">
                <div class="item" v-for="(chat, index) in chatList" :key="index" @click="() => selectChat(chat)">
                    <div class="left">
                        <div class="avatar">
                            <a-avatar
                                v-if="chat.users.gravatar"
                                :size="50"
                                :src="chat.users.gravatar"
                                class="avatarIcon"
                            />
                            <a-avatar v-else :style="{ backgroundColor: '#EC4B1D' }">
                                <div>
                                    {{
                                        ((chat.users.length ? chat.users[0].name : chat.fullname) || "*")
                                            .substr(0, 1)
                                            .toUpperCase()
                                    }}
                                </div>
                            </a-avatar>
                        </div>
                        <div class="info">
                            <div
                                class="name"
                                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                :content="getParticipants(chat)"
                            >
                                {{ getParticipants(chat) }}
                            </div>
                            <div
                                class="first-message"
                                v-html="messageText(getFirstMessage(chat).description)"
                                v-if="getFirstMessage(chat)"
                            ></div>
                        </div>
                    </div>
                    <div class="rigth">
                        <div class="date" style="color: var(--primary-text)">
                            {{ getDate(chat) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedConversationId && !loading">
            <ChatHistoryDetail
                :colors="colors"
                :message-styling="messageStyling"
                :vuescrollOptions="vuescrollOptions"
                :messages="messages"
                :participants="participants"
            />
        </div>
        <div class="loading-bar" v-if="loading">
            <DynamicSvg :name="'Loading'" />
        </div>
    </div>
</template>
<script>
import { fetchChatHistory } from "../../api/visitor";
import { mapState } from "vuex";
import log2 from "../../utils/log2";
import dateUtils from "../../utils/DateUtil";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import request from "../../utils/request";
import * as _ from "lodash";
import Input from "../../common/Input.vue";
import ChatHistoryDetail from "./ChatHistoryDetail.vue";
import DynamicSvg from "../../common/DynamicSvg.vue";

const log = log2("ChatHistoryList");
export default {
    name: "ChatHistoryListTwo",
    components: { Input, ChatHistoryDetail, DynamicSvg },
    props: {
        vuescrollOptions: {
            type: Object,
        },
        colors: {
            type: Object,
        },
        messageStyling: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedConversationId: undefined,
            chats: [],
            loading: true,
            messages: [],
            participants: [],
            page: 1,
            loadMore: false,
            searchValue: null,
            chatList: [],
        };
    },

    methods: {
        getDate(c) {
            return dateUtils.timeFromNow(c.createdDate);
        },
        getTitle() {
            const c = this.chats.find((x) => x._id === this.selectedConversationId);
            return `${this.$t("message.chatDate")} ` + dateUtils.formatDateTime(c.createdDate);
        },
        getParticipants(c) {
            if (c.users.length === 0) {
                return this.$t("message.you");
            } else if (c.users.length === 1) {
                return `${this.$t("message.you")} ${this.$t("message.and")} ${_.startCase(
                    _.head(c.users).name.trim().toLowerCase()
                )}`;
            } else {
                return [this.$t("message.you"), ...c.users.map((x) => _.startCase(x.name.trim().toLowerCase()))].join(
                    ","
                );
            }
        },
        getFirstMessage(c) {
            return c.messages[c.messages.length - 2];
        },
        getLastMessage(c) {
            return c.messages[c.messages.length - 1];
        },
        getChatHistory() {
            this.loading = true;
            fetchChatHistory(this.site._id, this.visitorId, this.page)
                .then((res) => {
                    log("fetchChatHistory", res.data);
                    const { conversations, totalCount, currentPage, pageSize } = res.data;
                    this.chats = [...this.chats, ...conversations];
                    this.chatList = [...this.chats, ...conversations];
                    this.loadMore = Math.ceil(totalCount / pageSize) !== currentPage;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        messageText(msg) {
            let escaped = htmlUnescape(msg.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });

            return res;
        },
        selectChat(c) {
            log("selectChat", c);
            this.selectedConversationId = c._id;
            this.loadOldMessages();
        },
        loadOldMessages() {
            log("loadOldMessages", this.selectedConversationId);
            this.loading = true;
            const convertMessages = (items) => {
                const allMessages = items
                    .map((x, i) => {
                        let type = "";
                        let author = "";
                        if (x.messageType === "system") {
                            type = "system";
                        } else if (["user", "chatbot"].includes(x.messageType)) {
                            type = "text";
                            author = x.userId || "Chatbot";
                        } else if (x.messageType.includes("chatbot")) {
                            type = x.messageType;
                            author = "Chatbot";
                        } else if (x.messageType === "private") {
                            type = "private";
                        } else if (x.messageType === "visitor") {
                            type = "text";
                            author = "me";
                        } else if (x.messageType === "user-media" || x.messageType === "visitor-media") {
                            author = x.messageType === "user-media" ? x.userId : "me";
                            if (
                                (!!x.asset.mime && x.asset.mime.includes("image")) ||
                                ["jpg", "jpeg", "png"].includes(x.asset.ext)
                            ) {
                                type = "image";
                            } else if (
                                (!!x.asset.mime && x.asset.mime.includes("audio")) ||
                                x.asset.ext.includes("mp3")
                            ) {
                                type = "audio";
                            } else {
                                type = "asset";
                            }
                        } else if (x.messageType === "visitor-location") {
                            author = x.messageType === "visitor-location" ? "me" : x.userId;
                            type = "location";
                        } else if (x.messageType === "user-location") {
                            author = x.messageType === "user-location" ? x.userId : "me";
                            type = "location";
                        } else if (x.messageType.startsWith("chatbot")) {
                            type = x.messageType;
                            author = "chatbot";
                        }
                        return {
                            type,
                            author,
                            data: {
                                text: x.message || x.description || _.get(x, "payload.text"),
                                meta: dateUtils.formatHour(x.createdDate),
                            },
                            raw: x,
                        };
                    })
                    .filter((x) => x !== undefined);
                log("allMessages", allMessages);
                return allMessages;
            };
            if (this.selectedConversationId);
            {
                return request({
                    url: `/conversations/${this.selectedConversationId}/messages`,
                    method: "get",
                })
                    .then((response) => {
                        this.messages = [];
                        let items = response.data.data;
                        items = _.orderBy(
                            _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                            (q) => new Date(q.createdDate).getTime(),
                            "asc"
                        );
                        log("messages ->", items);
                        this.messages = convertMessages(items);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            visitorId: (state) => state.chat.visitorId,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst",
                    "#fff"
                ),
            backgroundColorSecond: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond",
                    "#fff"
                ),
        }),
    },
    mounted() {
        dateUtils.initializeLocale(this.$i18n.locale);
        if (this.site && this.visitorId) this.getChatHistory();
    },
    updated() {
        dateUtils.updateLocale(this.$i18n.locale);
    },
    watch: {
        chats() {},
        searchValue() {
            this.chatList = this.chats.filter((chat) =>
                chat.users.some((user) => user.name.includes(this.searchValue))
            );
            if (!this.searchValue.length) {
                this.chatList = this.chats;
            }
        },
    },
};
</script>
<style lang="scss">
#ChatHistoryListTwo {
    overflow-y: scroll;
    overflow-x: hidden;

    .list-container {
        width: 100%;
        height: 100%;

        .header {
            display: flex;
            justify-content: center;
            padding: 0px 30px;
            margin-bottom: 10px;
            input {
                width: 100%;
            }
        }

        .list {
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;
                padding: 0px 20px;
                min-height: 40px;
                cursor: pointer;
                user-select: none;

                &:hover {
                    background-color: var(--hover-color);
                }

                .left {
                    display: flex;
                    align-items: center;

                    .avatar {
                        margin-right: 10px;
                    }

                    .info {
                        .name {
                            color: var(--primary-text);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            display: -webkit-box;
                        }

                        .first-message {
                            color: var(--agent-bubble-text-color);

                            p {
                                margin: 0;
                            }
                        }
                    }
                }

                .rigth {
                    .date {
                        color: var(--agent-bubble-text-color);
                    }
                }
            }
        }
    }

    .loading-bar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/ChatHistoryListTwo.vue